export default {
    noDataAvailable: 'Данные отсутствуют',
    elementByRequestNotFound: 'Элементов по данному запросу не найдено',
};
